import { render, staticRenderFns } from "./new-client-lead.vue?vue&type=template&id=983d67fe"
import script from "./new-client-lead.vue?vue&type=script&lang=js"
export * from "./new-client-lead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports